import type { Ref } from 'vue';
import { ref } from 'vue';
import type { CommentHeight } from '../types/comment';

export function useCommentsHeightsCalculator() {
  const commentsHeights: Ref<CommentHeight> = ref({});

  const addHeight = (commentId: string, height: number) => {
    commentsHeights.value[commentId] = height;
  };

  const removeHeight = (commentId: string) => {
    delete commentsHeights.value[commentId];
  };

  return {
    addHeight,
    removeHeight,
    commentsHeights,
  };
}
